import type {
  InsertTagTypeWithGroupNameMutation,
  InsertTagTypeWithGroupNameMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (trpcData: {
  Id: string;
}): InsertTagTypeWithGroupNameMutation => {
  return {
    insert_tag_type_one: {
      __typename: 'tag_type',
      TagTypeId: trpcData.Id,
    },
  };
};

export const useInsertTagTypeWithGroupNameTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.tag.insert.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.tag.pathKey(),
        });
      },
    }),
  });

  return {
    insertTagType: async (
      variables: InsertTagTypeWithGroupNameMutationVariables
    ): Promise<InsertTagTypeWithGroupNameMutation> => {
      const result = await mutation.mutateAsync({
        Name: variables.Name ?? '',
        Description: variables.Description ?? null,
        TagGroupName: variables.TagGroupName ?? null,
      });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
